import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ViewToggleWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const ContentWrapper = styled.div`
  margin-bottom: ${Spacing.S32};
`
